import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { TextInput } from "../../../components/textInput/TextInput";
import { CustomButton } from "../../../components/customButton/CustomButton";

export const ConexionesFilters = ({
    delegaciones,
    handleChange,
    handleTextClean,
    handleTextFilter,
    filters,
    months,
    years,
    handleSearch
}) => {
    return (
        <Grid
            container
            spacing={2}
            sx={{ marginBottom: '25px' }}
        >
            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 2.4 }}>
                <FormControl sx={{ backgroundColor: 'white', width: '100%' }} size='small'>
                    <InputLabel id='select-delegacion'>Delegación</InputLabel>
                    <Select
                        labelId='select-delegacion'
                        options={delegaciones}
                        label='Delegación'
                        onChange={handleChange}
                        value={filters?.idDelegacion ?? ''}
                        name='idDelegacion'
                    >
                        {delegaciones && delegaciones.map((delegacion) => {
                            // descarto TODAS
                            if (delegacion.id!=null)
                                return <MenuItem key={delegacion.id} value={delegacion.id}> {delegacion.displayName} </MenuItem>
                        })}
                    </Select>
                </FormControl>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 2.4 }}>
                <FormControl sx={{ backgroundColor: 'white', width: '100%' }} size='small'>
                    <InputLabel id='select-area-responsable'>Mes</InputLabel>
                    <Select
                        labelId='select-area-responsable'
                        options={months}
                        label='Mes'
                        onChange={handleChange}
                        value={filters?.month || undefined}
                        name='month'
                    >
                        {months.map((month) => {
                            return <MenuItem key={month.id} value={month.id}> {month.displayName} </MenuItem>
                        })}
                    </Select>
                </FormControl>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 2.4 }}>
                <FormControl sx={{ backgroundColor: 'white', width: '100%' }} size='small'>
                    <InputLabel id='select-area-responsable'>Año</InputLabel>
                    <Select
                        labelId='select-area-responsable'
                        options={years}
                        label='Año'
                        onChange={handleChange}
                        value={filters?.year || undefined}
                        name='year'
                    >
                        {years.map((year) => {
                            return <MenuItem key={year.id} value={year.id}> {year.displayName} </MenuItem>
                        })}
                    </Select>
                </FormControl>
            </Grid>
            <Grid size={{ xs: 24, sm: 6, md: 4, lg: 2.4 }}>
                <TextInput
                    searchIcon
                    label="Buscar"
                    name="txtFiltro"
                    onClearButtonClick={handleTextClean}
                    value={filters?.txtFiltro}
                    onChange={handleChange}
                    onKeyUp={handleTextFilter}
                />
            </Grid>
            <Grid sx={{ textAlign: 'right' }} size={{ xs: 12, sm: 6, md: 4, lg: 2.4 }}>
                <CustomButton
                    className='button-header'
                    disabled={!delegaciones?.length || !filters?.idDelegacion || !filters?.month || !filters?.year}
                    label='Buscar'
                    onClick={handleSearch}
                    variant='contained'
                />
            </Grid>
        </Grid>
    )
}
